export const hideOnSmallBrowserWidthClass = "hide-on-small-browser-width";
export const hideOnLargeBrowserWidthClass = "hide-on-large-browser-width";
export const smallBrowserWidthMax = "767px";
export const largeBrowserWidthMin = "768px";
export const tabletOrLargerDevices = "480px";
export const returnistaRedesignBoxShadow = "1px 2px 12px rgba(0, 0, 0, 0.16)";
export const returnBarSupportLink = "https://www.returnbarsupport.happyreturns.com/support-home-1";

export const MOBILE_BREAKPOINT = 758;
